import { createHook, createStore } from '@atlassian/react-sweet-state';

const store = createStore({
	initialState: {
		isSLAHierarchicalGoalsEnabled: false,
		isPriorityNameChanged: {},
		prioritiesSelected: {},
	},
	actions: {
		updateSLAHierarchicalGoalsEnabledFF:
			(value) =>
			async ({ setState }) => {
				setState({
					isSLAHierarchicalGoalsEnabled: value,
				});
			},
		updateIsPriorityNameChanged:
			(metricId, goalId, value) =>
			async ({ setState, getState }) => {
				const { isPriorityNameChanged } = getState();
				// @ts-expect-error TS-7053
				const isPriorityChangedForMetricId = isPriorityNameChanged?.[metricId] || {};

				if (value && !isPriorityChangedForMetricId?.[goalId]) {
					setState({
						isPriorityNameChanged: {
							...isPriorityNameChanged,
							[metricId]: {
								...isPriorityChangedForMetricId,
								[goalId]: value,
							},
						},
					});
				}
			},
		updatePrioritiesConsumed:
			(metricId, goalId, value = []) =>
			({ setState, getState }) => {
				const { prioritiesSelected } = getState();
				setState({
					prioritiesSelected: {
						...prioritiesSelected,
						[metricId]: {
							// @ts-expect-error - TS7053
							...prioritiesSelected[metricId],
							[goalId]: [...value],
						},
					},
				});
			},
	},
});

export const useSLAHierarchicalGoalsEnabled = createHook(store);
